module.exports = "/_next/static/images/LCTS-7baa8dd596289864d2b5bd671790e3c0.svg";